import React from "react";
import { HeartFilled, CloseOutlined } from "@ant-design/icons";
import { HeartStyle, galleryImg } from "../data/data";
import styled from "styled-components";
const Layout = styled.div`
  background: #f6f6f6;
  min-height: 500px;
  font-family: "Oswald", sans-serif;
  .gal-content {
    text-align: center;
    padding: 80px 0 50px 0;
  }
  p {
    padding-top: 12px;
  }
  h1 {
    font-size: 37px;
  }
  .gallery-wrap {
    column-width: 33%;
    column-count: 3;
    @media (max-width: 991px) {
      column-count: 2;
    }
    @media (max-width: 480px) {
      column-count: 1;
      column-width: 100%;
    }
  }
  .gallery-wrap img {
    width: 100%;
  }
  .pics {
    transition: all 350ms ease;
    cursor: pointer;
    margin-bottom: 12px;
  }
  .model {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    display: grid;
    place-items: center;
    background: rgba(0, 0, 0, 0.888);
    transition: opacity 0.4s ease, visibity 0.4s ease, transform 0.5s ease-out;
    visibility: hidden;
    /* opacity: 0; */
    transform: scale(0);
    overflow: hidden;
    z-index: 999999;
  }
  .model.open {
    visibility: visible;
    opacity: 1;
    transform: scale(1);
  }
  .model img {
    width: auto;
    max-width: 100%;
    height: auto;
    display: block;
    line-height: 0;
    box-sizing: border-box;
    padding: 20px 0 20px;
    max-height: 100%;
    margin: 0 auto;
  }
  .model.open svg {
    position: fixed;
    top: 10px;
    right: 10px;
    width: 2rem;
    height: 2rem;
    background: rgba(0, 0, 0, 0.4);
    padding: 5px;
    color: #fff;
    cursor: pointer;
  }
  .gallery-wrap .pics:hover {
    filter: opacity(0.8);
  }
`;

function Gallery() {
  const [tempImg, setTempImg] = React.useState("");
  const [model, setModel] = React.useState(false);

  const getImg = (imgUrl) => {
    setTempImg(imgUrl);
    setModel(true);
  };
  return (
    <>
      <Layout>
        <div className="gal-content">
          <h1>GALLERY</h1>
          <HeartStyle>
            <span className="white-line"></span>
            <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
            <HeartFilled
              style={{
                fontSize: 19,
                marginLeft: -5,
                color: "white",
              }}
            />
            <span className="white-line"></span>
          </HeartStyle>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
            ultrices malesuada ante quis <br /> pharetra. Nullam non bibendum
            dolor. Ut vel turpis
          </p>
        </div>
        <div className={model ? "model open" : "model"}>
          <img src={tempImg} alt="gallery pix" />
          <CloseOutlined
            onClick={() => {
              setModel(false);
            }}
          />
        </div>
        <div className="gallery-wrap">
          {galleryImg &&
            galleryImg.map((item) => {
              return (
                <div
                  className="pics"
                  key={item.id}
                  onClick={() => getImg(item.imgUrl)}
                >
                  <img src={item.imgUrl} alt="pics" />
                </div>
              );
            })}
        </div>
      </Layout>
    </>
  );
}

export default Gallery;
